import type { TUploadInputFileErrorMap } from './upload-input-file.types'

export const UPLOAD_INPUT_FILE_ERROR_MAPS: TUploadInputFileErrorMap = {
  fileExtension: {
    code: 1,
    name: 'file_extension_not_supported',
  },
  maxFiles: {
    code: 2,
    name: 'max_files_exceeded',
  },
}
